export enum Cmg1003SubSectionTypes {
  primaryBorrower = 'primaryBorrower',
  additionalBorrower = 'additionalBorrower',
  loanOfficerInfo = 'loanOfficerInfo',
  primaryBorrowerDetails = 'primaryBorrowerDetails',
  primaryBorrowerPresentAddress = 'primaryBorrowerPresentAddress',
  primaryborrowerMailingAddress = 'primaryborrowerMailingAddress',
  primaryBorrowerPreviousAddress = 'primaryBorrowerPreviousAddress',
  additionalBorrowerDetails = 'additionalBorrowerDetails',
  additionalBorrowerPresentAddress = 'additionalBorrowerPresentAddress',
  additionalBorrowerMailingAddress = 'additionalBorrowerMailingAddress',
  additionalBorrowerPreviousAddress = 'additionalBorrowerPreviousAddress',
  loanMortgageType = 'loanMortgageType',
  loanOriginationChannel = 'loanOriginationChannel',
  loanReferralDetails = 'loanReferralDetails',
  loanHouseholdMembers = 'loanHouseholdMembers',
  assetsOther = 'assetsOther',
  assetsCredit = 'assetsCredits',
  assetsLiabilities = 'assetsLiabilities',
  assetsLiabilitiesEditor = 'assetsLiabilitiesEditor',
  assetsReo = 'assetsReos',
  antiSteering = 'antiSteering',
  gmiHdma = 'gmiHdma',
  primaryBorrowerGmiSupplemental = 'primaryBorrowerGmiSupplemental',
  additionalBorrowerGmiSupplemental = 'additionalBorrowerGmiSupplemental',
  allBorrowers = 'allBorrowers',
  ausLoanInfo = 'ausLoanInfo',
  ausRequestInfo = 'ausRequestInfo',
}
